import lodash from "lodash"

export function stringifyCustoms(values) {
  return lodash.map(values, value => ({
    ...lodash.omit(value, ["value", "isDelete"]),
    value: lodash.get(value, "value.value"),
    valueCurrency: lodash.get(value, "value.currency")
  }))
}
